export const authModalsMarkup = String.raw`<!-- ====== AUTH MODALS ====== -->

<!-- Login Modal -->
<div class="modal-overlay" id="loginModal">
  <div class="modal modal-auth">
    <div class="modal-auth-topbar">
      <div class="modal-auth-brand">
        <img class="auth-brand-logo" src="/assets/brand/deepmox-wordmark-320.png" alt="DeepMox">
      </div>
      <button type="button" class="modal-close" data-proto-click="closeLoginModal()" aria-label="Close login">
        <svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
      </button>
    </div>
    <div class="modal-auth-header">
      <h3 class="modal-auth-title">Log In</h3>
      <p id="loginIntentNote" class="modal-auth-sub" hidden></p>
    </div>
    <div class="modal-auth-body">
      <!-- Social sign-in (top, primary) -->
      <div class="auth-social-stack">
        <button type="button" class="auth-social-btn" id="loginGoogleBtn" data-proto-click="handleSocialLogin('google')" data-transient-action data-idle-label="Continue with Google" data-idle-disabled="false">
          <svg width="18" height="18" viewBox="0 0 24 24"><path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z" fill="#4285F4"></path><path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"></path><path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"></path><path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"></path></svg>
          <span data-idle-label-target>Continue with Google</span>
        </button>
      </div>
      <div class="auth-divider"><span>or with email</span></div>
      <!-- Email login -->
      <form data-proto-submit="handleLogin()" novalidate>
        <div class="auth-field">
          <label class="wizard-label" for="loginEmail">Email</label>
          <input type="email" class="input" id="loginEmail" name="username" placeholder="you@example.com" autocomplete="username" maxlength="254" data-reset-on-enter>
        </div>
        <div class="auth-field">
          <label class="wizard-label" for="loginPassword">Password</label>
          <input type="password" class="input" id="loginPassword" name="password" placeholder="Enter your password" autocomplete="current-password" maxlength="128" data-reset-on-enter>
        </div>
        <div class="auth-forgot-row">
          <a href="#" data-proto-click="closeLoginModal();showForgotModal();return false;" class="auth-link">Forgot password?</a>
        </div>
        <p id="loginFormAlert" class="auth-form-alert" role="alert" aria-live="assertive" data-transient-feedback hidden></p>
        <div id="loginTurnstileContainer" class="auth-turnstile-container"></div>
        <div id="loginTurnstileStatus" class="auth-turnstile-status" role="status" aria-live="polite" hidden>
          <span id="loginTurnstileStatusText"></span>
          <button type="button" class="auth-turnstile-retry" data-proto-click="retryAuthTurnstile('login')">Retry verification</button>
        </div>
        <button type="submit" class="btn btn-primary btn-lg w-full auth-primary-btn" id="loginSubmitBtn" data-transient-action data-idle-label="Log In">Log In</button>
        <p class="auth-legal-disclosure">By continuing, you agree to DeepMox’s <button type="button" data-proto-click="openLegalDocument('terms')" class="auth-link auth-legal-link">Terms of Service</button> and acknowledge that you have read DeepMox’s <button type="button" data-proto-click="openLegalDocument('privacy')" class="auth-link auth-legal-link">Privacy Policy</button>.</p>
        <p class="auth-foot auth-foot--separated">
          Don't have an account? <a href="#" data-proto-click="closeLoginModal();showRegisterModal();return false;" class="auth-link-strong">Sign up</a>
        </p>
      </form>
    </div>
  </div>
</div>

<!-- Register Modal -->
<div class="modal-overlay" id="registerModal">
  <div class="modal modal-auth">
    <div class="modal-auth-topbar">
      <div class="modal-auth-brand">
        <img class="auth-brand-logo" src="/assets/brand/deepmox-wordmark-320.png" alt="DeepMox">
      </div>
      <button type="button" class="modal-close" data-proto-click="closeRegisterModal()" aria-label="Close register">
        <svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
      </button>
    </div>
    <div class="modal-auth-header">
      <h3 class="modal-auth-title">Create Account</h3>
      <p class="modal-auth-sub" id="registerIntentNote" hidden></p>
    </div>
    <div class="modal-auth-body">
      <div id="registerForm">
        <div class="auth-social-stack">
          <button type="button" class="auth-social-btn" id="registerGoogleBtn" data-proto-click="handleSocialLogin('google')" data-transient-action data-idle-label="Continue with Google" data-idle-disabled="false">
            <svg width="18" height="18" viewBox="0 0 24 24"><path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z" fill="#4285F4"></path><path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"></path><path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"></path><path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"></path></svg>
            <span data-idle-label-target>Continue with Google</span>
          </button>
        </div>
        <div class="auth-divider"><span>or with email</span></div>
        <div class="auth-field">
          <label class="wizard-label">Display name</label>
          <input type="text" class="input" id="regName" placeholder="Your name" autocomplete="name" minlength="2" maxlength="60" data-reset-on-enter>
        </div>
        <div class="auth-field">
          <label class="wizard-label">Email</label>
          <input type="email" class="input" id="regEmail" placeholder="you@example.com" autocomplete="email" maxlength="254" data-reset-on-enter>
        </div>
        <div class="auth-field">
          <label class="wizard-label">Password</label>
          <input type="password" class="input" id="regPassword" placeholder="At least 8 characters" autocomplete="new-password" minlength="8" maxlength="128" data-reset-on-enter>
        </div>
        <div class="auth-field">
          <label class="wizard-label">Confirm Password</label>
          <input type="password" class="input" id="regPasswordConfirm" placeholder="Re-enter password" autocomplete="new-password" minlength="8" maxlength="128" data-reset-on-enter>
        </div>
        <p id="registerFormAlert" class="auth-form-alert" role="alert" aria-live="assertive" data-transient-feedback hidden></p>
        <div id="registerTurnstileContainer" class="auth-turnstile-container"></div>
        <div id="registerTurnstileStatus" class="auth-turnstile-status" role="status" aria-live="polite" hidden>
          <span id="registerTurnstileStatusText"></span>
          <button type="button" class="auth-turnstile-retry" data-proto-click="retryAuthTurnstile('register')">Retry verification</button>
        </div>
        <button class="btn btn-primary btn-lg w-full auth-primary-btn" id="registerSubmitBtn" data-proto-click="handleRegister()" data-transient-action data-idle-label="Create Account">Create Account</button>
        <p class="auth-legal-disclosure">By continuing, you agree to DeepMox’s <button type="button" data-proto-click="openLegalDocument('terms')" class="auth-link auth-legal-link">Terms of Service</button> and acknowledge that you have read DeepMox’s <button type="button" data-proto-click="openLegalDocument('privacy')" class="auth-link auth-legal-link">Privacy Policy</button>.</p>
        <p class="auth-foot auth-foot--separated">
          Already have an account? <a href="#" data-proto-click="closeRegisterModal();showLoginModal();return false;" class="auth-link-strong">Log in</a>
        </p>
      </div>
      <div id="registerSuccess" style="display:none;text-align:center;padding:20px 0;">
        <div class="forgot-success-icon" id="registerFeedbackIcon" data-feedback-kind="success" role="img" aria-label="Success">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="var(--success)" stroke-width="2.5"><polyline points="20 6 9 17 4 12"></polyline></svg>
        </div>
        <h4 class="forgot-success-title" id="registerRecoveryTitle">Check your email</h4>
        <p class="forgot-success-detail" id="registerRecoveryDetail">We've sent a verification link to your email. Click the link to activate your account.</p>
        <button class="btn btn-primary btn-lg w-full auth-primary-btn" id="registerRecoveryLoginBtn" data-proto-click="closeRegisterModal();showLoginModal()">Log in</button>
        <div id="resendVerificationControls">
          <div class="auth-divider"><span>Didn't receive it?</span></div>
          <div id="resendVerificationTurnstileContainer" class="auth-turnstile-container"></div>
          <div id="resendVerificationTurnstileStatus" class="auth-turnstile-status" role="status" aria-live="polite" hidden>
            <span id="resendVerificationTurnstileStatusText"></span>
            <button type="button" class="auth-turnstile-retry" data-proto-click="retryAuthTurnstile('resend')">Retry verification</button>
          </div>
          <p id="resendVerificationFeedback" class="forgot-success-detail" role="status" aria-live="polite" data-transient-feedback hidden></p>
          <button class="btn btn-primary btn-lg w-full auth-primary-btn" id="resendVerificationSubmitBtn" data-proto-click="handleResendVerification()" data-transient-action data-idle-label="Resend verification email">Resend verification email</button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Forgot Password Modal -->
<div class="modal-overlay" id="forgotModal">
  <div class="modal modal-auth modal-auth-narrow">
    <div class="modal-auth-topbar">
      <div class="modal-auth-brand">
        <img class="auth-brand-logo" src="/assets/brand/deepmox-wordmark-320.png" alt="DeepMox">
      </div>
      <button type="button" class="modal-close" data-proto-click="closeForgotModal()" aria-label="Close forgot password">
        <svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
      </button>
    </div>
    <div class="modal-auth-header">
      <h3 class="modal-auth-title">Reset Password</h3>
      <p class="modal-auth-sub">We'll send a reset link to your email</p>
    </div>
    <div class="modal-auth-body">
      <div id="forgotForm" data-reset-view="show">
        <div class="auth-field">
          <label class="wizard-label">Email address</label>
          <input type="email" class="input" id="forgotEmail" placeholder="you@example.com" autocomplete="email" maxlength="254" data-reset-on-enter>
        </div>
        <p id="forgotFormAlert" class="auth-form-alert" role="alert" aria-live="assertive" data-transient-feedback hidden></p>
        <div id="forgotTurnstileContainer" class="auth-turnstile-container"></div>
        <div id="forgotTurnstileStatus" class="auth-turnstile-status" role="status" aria-live="polite" hidden>
          <span id="forgotTurnstileStatusText"></span>
          <button type="button" class="auth-turnstile-retry" data-proto-click="retryAuthTurnstile('forgot')">Retry verification</button>
        </div>
        <button class="btn btn-primary btn-lg w-full auth-primary-btn" id="forgotSubmitBtn" data-proto-click="handleForgotPassword()" data-transient-action data-idle-label="Send Reset Link">Send Reset Link</button>
        <p class="auth-foot">
          Remember your password? <a href="#" data-proto-click="closeForgotModal();showLoginModal();return false;" class="auth-link-strong">Log in</a>
        </p>
      </div>
	  <div id="forgotSuccess" style="text-align:center;padding:20px 0;" data-reset-view="hide" hidden>
        <div class="forgot-success-icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="var(--success)" stroke-width="2.5"><polyline points="20 6 9 17 4 12"></polyline></svg>
        </div>
        <h4 class="forgot-success-title">Check your email</h4>
        <p class="forgot-success-detail">We've sent a password reset link to your email. It may take a minute to arrive.</p>
        <button class="btn btn-primary btn-lg w-full auth-primary-btn" data-proto-click="closeForgotModal()">Done</button>
      </div>
    </div>
  </div>
</div>

<!-- Same-email Google link confirmation -->
<div class="modal-overlay" id="oauthLinkModal">
  <div class="modal modal-auth modal-auth-narrow">
    <div class="modal-auth-topbar">
      <div class="modal-auth-brand"><img class="auth-brand-logo" src="/assets/brand/deepmox-wordmark-320.png" alt="DeepMox"></div>
      <button type="button" class="modal-close" data-proto-click="handleOAuthLinkCancel()" aria-label="Cancel Google account link"><svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg></button>
    </div>
    <div class="modal-auth-header">
      <h3 class="modal-auth-title">Confirm your account</h3>
      <p class="modal-auth-sub">This Google email already has a password account. Enter that password once to link Google and sign in.</p>
    </div>
    <div class="modal-auth-body">
      <div class="auth-field">
        <label class="wizard-label">DeepMox password</label>
        <input type="password" class="input" id="oauthLinkPassword" autocomplete="current-password" maxlength="128" data-reset-on-enter>
      </div>
      <div class="auth-forgot-row">
        <a href="#" data-proto-click="handleOAuthLinkForgotPassword()" class="auth-link">Forgot password?</a>
      </div>
      <p id="oauthLinkFormAlert" class="auth-form-alert" role="alert" aria-live="assertive" data-transient-feedback hidden></p>
      <div id="oauthLinkTurnstileContainer" class="auth-turnstile-container"></div>
      <div id="oauthLinkTurnstileStatus" class="auth-turnstile-status" role="status" aria-live="polite" hidden>
        <span id="oauthLinkTurnstileStatusText"></span>
        <button type="button" class="auth-turnstile-retry" data-proto-click="retryAuthTurnstile('oauthLink')">Retry verification</button>
      </div>
      <button class="btn btn-primary btn-lg w-full auth-primary-btn" id="oauthLinkSubmitBtn" data-proto-click="handleOAuthLinkComplete()" data-transient-action data-idle-label="Link Google and sign in">Link Google and sign in</button>
    </div>
  </div>
</div>

`;
